/**
 * Runs `run` once the main thread is idle (requestIdleCallback, at most
 * `timeoutMs` later; Safari has none and runs it on the next task). For
 * code fetched ahead of use: started after hydration's own work, it
 * stays out of the page's first long tasks. Returns a cancel function.
 */
export function whenIdle(run: () => void, timeoutMs = 2000): () => void {
  const w = window as Window & {
    requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number;
    cancelIdleCallback?: (id: number) => void;
  };
  if (w.requestIdleCallback) {
    const id = w.requestIdleCallback(run, { timeout: timeoutMs });
    return () => w.cancelIdleCallback?.(id);
  }
  const timer = setTimeout(run, 0);
  return () => clearTimeout(timer);
}
